import jsonParse from "web/utils/data/parser/string/jsonParse";
import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { ICategoryCount } from "web/types/CategoryCount";
import { IGtmEcommerceImpressionPromotions } from "web/types/Gtm";
import {
  IPageGeneratorModule,
  IParsedParameter,
  PageGeneratorModuleType,
} from "web/types/PageGenerator";
import { Nullable } from "web/types/Utils";

import { IPromoCounter } from "../pageGeneratorQuery";
import { createGtmImpressionProps } from "./gtmPromoEvent";
import handleGraphicGTM from "./handleGraphicGTM";
import handleHtmlGTM from "./handleHtmlGTM";

interface IHandlePageGeneratorGTMArgs {
  modulesSorted: IPageGeneratorModule[];
  promoCounter: IPromoCounter[];
  availableCategories: ICategoryCount[];
  isMobile?: boolean;
}

const HANDLED_TYPES = [
  PageGeneratorModuleType.HTML,
  PageGeneratorModuleType.SLIDER,
  PageGeneratorModuleType.TRIPLE_GRAPHIC,
];

const handlePageGeneratorGTM = ({
  modulesSorted,
  promoCounter,
  availableCategories,
}: IHandlePageGeneratorGTMArgs) => {
  const impressions: Nullable<IGtmEcommerceImpressionPromotions[]>[] = [];
  modulesSorted.forEach(({ type, parameters, id }) => {
    if (!HANDLED_TYPES.includes(type)) {
      return;
    }
    const promoItem = promoCounter?.find((item) => item.id === id);
    const params = jsonParse<IParsedParameter>(parameters);

    switch (type) {
      case PageGeneratorModuleType.SLIDER:
        impressions.push(
          handleGraphicGTM({
            promoItem,
            availableCategories,
            params,
            imageField: "graphic_file",
          })
        );
        break;
      case PageGeneratorModuleType.TRIPLE_GRAPHIC:
        impressions.push(
          handleGraphicGTM({
            promoItem,
            availableCategories,
            params,
            imageField: "background_file",
          })
        );
        break;
      case PageGeneratorModuleType.HTML:
        impressions.push(handleHtmlGTM({ promoItem, params }));
        break;
      default:
        break;
    }
  });

  const gtmOptions = impressions
    .filter(Boolean)
    .flat() as IGtmEcommerceImpressionPromotions[];

  if (isArrayHasItems(gtmOptions)) {
    createGtmImpressionProps(gtmOptions);
  }
};

export default handlePageGeneratorGTM;
